import tokens from './tokens'
import { SerializedFarmConfig } from './types'

const priceHelperLps: SerializedFarmConfig[] = [
  /**
   * These LPs are just used to help with price calculation for MasterChef LPs (farms.ts).
   * This list is added to the MasterChefLps and passed to fetchFarm. The calls to get contract information about the token/quoteToken in the LP are still made.
   * The absence of a PID means the masterchef contract calls are skipped for this farm.
   * Prices are then fetched for all farms (masterchef + priceHelperLps).
   * Before storing to redux, farms without a PID are filtered out.
   */
  {
    pid: null,
    lpSymbol: 'ETH-CAMP LP',
    lpAddresses: {
      97: '',
      56: '0x807B6d1C46Ff507Fab3F2E959185b84704576FFd',
      1: '0x9a5ba50d225f30C17305662C8e7A44106356AFdF',
    },
    token: tokens.camp,
    quoteToken: tokens.weth,
  },
]

export default priceHelperLps
